export default "__VITE_ASSET__DH8opD0B__"